import Vue from 'vue';
import App from './App.vue';

// vue-meta
import VueMeta from 'vue-meta';

// vuex
import store from './store';

// vue router
import router from './router';
import vuetify from './plugins/vuetify';
import VueCookies from 'vue-cookies';

// Stripe
import { StripePlugin } from '@vue-stripe/vue-stripe';
const options = {
  pk: 'pk_test_51OajwDBXlg19c3VQ3d6fc9AOVS6k8h7o4x4r6j7stIYXA1EV0nKbkX0PeRtWHpG5pS4o8RnTMO7Wi8lO2mxkBzbR00z4qJMnPa',
  testMode: true, // Boolean. To override the insecure host warning
  stripeAccount: process.env.STRIPE_ACCOUNT,
  apiVersion: process.env.API_VERSION,
  locale: process.env.LOCALE
};

// Event Bus
import EventBus from './helpers/eventBus';
Vue.prototype.$eventBus = EventBus;

// mixins
import mixinHelper from './helpers/mixinHelper';

Vue.config.productionTip = false;
Vue.use(VueCookies, { expires: '900d' });
Vue.use(StripePlugin, options);
Vue.use(VueMeta);
Vue.mixin(mixinHelper);

export default new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
